'use client';

import { useSearchParams } from 'next/navigation';
import { getAuthSession } from '../lib/authSession';
import { getWorkspaceContext } from '../lib/workspaceContext';

export const useWorkspaceScope = () => {
  const searchParams = useSearchParams();
  const session = getAuthSession();
  const stored = getWorkspaceContext();

  const teamId = searchParams?.get('teamId') ?? stored?.teamId ?? '';
  const projectId = searchParams?.get('projectId') ?? stored?.projectId ?? '';
  const hasWorkspaceContext = teamId.length > 0 && projectId.length > 0;
  const contextQuery = hasWorkspaceContext ? `?teamId=${teamId}&projectId=${projectId}` : '';

  return {
    session,
    token: session?.token ?? null,
    teamId,
    projectId,
    hasWorkspaceContext,
    contextQuery,
  };
};
